const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID as string

declare global {
  interface Window {
    google: {
      accounts: {
        id: {
          initialize: (config: {
            client_id: string
            callback: (response: { credential: string }) => void
            auto_select?: boolean
            cancel_on_tap_outside?: boolean
            use_fedcm_for_prompt?: boolean
          }) => void
          prompt: (
            momentListener?: (notification: {
              isNotDisplayed: () => boolean
              isSkippedMoment: () => boolean
              getDismissedReason: () => string
              getMomentType: () => string
            }) => void
          ) => void
          cancel: () => void
        }
      }
    }
  }
}

let sdkReady: Promise<void> | null = null

function loadSDK(): Promise<void> {
  if (sdkReady) return sdkReady
  sdkReady = new Promise((resolve, reject) => {
    if (typeof window.google !== 'undefined') { resolve(); return }
    const script = document.createElement('script')
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Google SDK ачааллахад алдаа гарлаа'))
    document.head.appendChild(script)
  })
  return sdkReady
}

export async function googleLogin(): Promise<string> {
  if (!GOOGLE_CLIENT_ID) {
    throw new Error('Google Client ID тохируулаагүй байна')
  }

  await loadSDK()

  return new Promise((resolve, reject) => {
    let settled = false

    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: (response) => {
        if (settled) return
        settled = true
        if (response?.credential) {
          resolve(response.credential)
        } else {
          reject(new Error('Google нэвтрэлт цуцлагдсан'))
        }
      },
      cancel_on_tap_outside: true,
      use_fedcm_for_prompt: true,
    })

    window.google.accounts.id.prompt((notification) => {
      if (settled) return
      if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
        settled = true
        const reason = notification.isNotDisplayed()
          ? 'Google One Tap харуулах боломжгүй байна. Browser-ийн тохиргооноос "Block third-party cookies" унтраана уу.'
          : 'Google нэвтрэлт цуцлагдсан'
        reject(new Error(reason))
      }
    })
  })
}
